var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#292929"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 26.0002H18.6667M24 17.3335C24 16.2726 23.5786 15.2552 22.8284 14.5051C22.0783 13.7549 21.0609 13.3335 20 13.3335C18.9391 13.3335 17.9217 13.7549 17.1716 14.5051C16.4214 15.2552 16 16.2726 16 17.3335C16 19.3936 15.4803 20.8041 14.8998 21.7371C14.4101 22.5241 14.1652 22.9176 14.1742 23.0273C14.1842 23.1489 14.2099 23.1952 14.3079 23.2679C14.3963 23.3335 14.7951 23.3335 15.5926 23.3335H24.4074C25.2049 23.3335 25.6037 23.3335 25.6922 23.2679C25.7901 23.1952 25.8158 23.1489 25.8258 23.0273C25.8348 22.9176 25.5899 22.5241 25.1002 21.7371C24.5197 20.8041 24 19.3936 24 17.3335Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.3541ee7425f749248fb3865a4dce3121.svg";
export { ForwardRef as ReactComponent };